import { Helmet } from "react-helmet-async";

export const Seo = ({ title, description, lang = "it" }) => (
    <Helmet>
        <title>{title}</title>
        {description && <meta name="description" content={description} />}
        <meta property="og:title" content={title} />
        {description && <meta property="og:description" content={description} />}
        <meta property="og:locale" content={lang === "it" ? "it_IT" : "en_US"} />
        <html lang={lang} />
    </Helmet>
);
